import React from 'react';

const OrganizationList = ({ organizations, isSuperAdmin, profile, onEdit, styles }) => {
  if (organizations.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '40px', color: '#999' }}>
        No organizations found. {isSuperAdmin && 'Create one to get started.'}
      </div>
    );
  }

  return (
    <div style={styles.orgList}>
      {organizations.map((org) => (
        <div key={org.id} style={styles.orgItem}>
          <div style={styles.orgInfo}>
            <div style={styles.orgName}>{org.name}</div>
            <div style={styles.orgDetails}>
              Slug: {org.slug} | Timezone: {org.settings?.timezone || 'Not set'} | Currency:{' '}
              {org.settings?.currency || 'Not set'} | Season: {org.settings?.season || 'Not set'}
            </div>
          </div>
          {(isSuperAdmin || profile?.organization_id === org.id) && (
            <button
              style={{ ...styles.button, ...styles.primaryButton }}
              onClick={() => onEdit(org)}
            >
              Edit
            </button>
          )}
        </div>
      ))}
    </div>
  );
};

export default OrganizationList;
